// src/firebaseConfig.ts
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

function requireEnv(name: string): string {
  const value = process.env[name];
  if (!value) {
    throw new Error(
      `Missing required env var: ${name}. Check .env.${process.env.NODE_ENV} (or .env.${process.env.NODE_ENV}.local).`
    );
  }
  return value;
}

const firebaseConfig = {
  apiKey: requireEnv("REACT_APP_FIREBASE_API_KEY"),
  authDomain: requireEnv("REACT_APP_FIREBASE_AUTH_DOMAIN"),
  projectId: requireEnv("REACT_APP_FIREBASE_PROJECT_ID"),
  storageBucket: requireEnv("REACT_APP_FIREBASE_STORAGE_BUCKET"),
  messagingSenderId: requireEnv("REACT_APP_FIREBASE_MESSAGING_SENDER_ID"),
  appId: requireEnv("REACT_APP_FIREBASE_APP_ID"),
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
